module.exports = __webpack_public_path__ + "img/avatar.d5a816ad.png";